
import { TodoService } from "@/services/todo.service";
import { useService } from "use-vue-service";
import { defineComponent, ref } from "vue";

export default defineComponent({
  setup() {
    const newTodo = ref("");
    const todoService = useService(TodoService);
    const addNewTodo = () => {
      todoService.addTodo(newTodo.value);
      newTodo.value = "";
    };
    return {
      addNewTodo,
      newTodo
    };
  }
});
